import React, {useContext, useEffect, useState} from "react";
import TourListItem from "@/components/TourListItem";
import i18n from "../../i18n";
import {ToursContext} from "@/ToursContext";
import TourService from "@/services/TourService";
import {useNavigate, useParams} from "react-router-dom";
import { createVueWrapper } from '@/vue-wrapper'
import TourListItemVue from '@/components/TourListItem.vue'

const VueTourListItem = createVueWrapper(TourListItemVue)

export default function Tours() {

    const [accountTours, setAccountTours] = useState([]);

    const navigate = useNavigate();

    // params
    const params = useParams();

    useEffect(() => {

        const fetchTours = async () => {
            console.log("async fetchTours");
            try {
                const tourResponse = await TourService.fetchTourList(i18n, params);
                if (tourResponse) {
                    console.log(tourResponse);
                    setAccountTours(tourResponse);
                } else {
                    console.log("no active tours found, redirect to not-found");
                    navigate(`/${params.language ? `${params.language}/` : ''}not-found`);
                }
            } catch (e ) {
                console.error(e);
            }
        }

        fetchTours();
    }, [])

    return (
        <>
            {accountTours && accountTours.length > 0 &&
                <div>
                    {accountTours.map((tour) => (
                        <VueTourListItem 
                            key={tour.id}
                            tour={tour}
                            params={params}
                        />
                    ))}
                </div>
            }
        </>
    );
}